<template>
  <div class="chuKuZuoyeWarp">
    <el-tabs v-model="activeName" type="card" style="margin-left:10px;">
      <el-tab-pane label="应收明细" name="one" style="">
        <div ref="searchBox" class="searchBox">
          <!-- 查询条件 -->
          <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini"
          label-width="100px">
            <el-form-item label="运单号:" class="item1">
              <el-input placeholder="" type="textarea" v-model="searchFrom.wayNos" class="gjh" style="width: 150px;"></el-input>
            </el-form-item>
            <el-form-item label="创建时间:">
              <el-date-picker
                v-model="createTimes"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="签收时间:">
              <el-date-picker
                v-model="actualSignings"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              ></el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="结算客户:" prop="payee">
              <el-input v-model="searchFrom.payee" size="mini" placeholder="请输入结算客户"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="结算方式:">
              <el-select v-model="searchFrom.incomePattern" placeholder="请选择" style="width:175px" size="mini">
                <el-option v-for="item in incomeList" :key="item.showName" :label="item.showName" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="结算状态:">
              <el-select size="mini" v-model="searchFrom.ysSettlementStates" placeholder="请选择结算状态">
                <el-option v-for="item in ysSettlementList" :label="item.showName" :key="item.value"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开票状态:">
              <el-select size="mini" v-model="searchFrom.ysInvoicingStates" placeholder="请选择开票状态">
                <el-option v-for="item in ysInvoicingList" :label="item.showName" :key="item.showName" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="运单号:" prop="wayNo">
              <el-input v-model="searchFrom.wayNo" size="mini" placeholder="请输入运单号"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="货物类型:">
              <el-select size="mini" v-model="searchFrom.productTypeName" placeholder="请选择货物类型"
                style="width:175px">
                <el-option v-for="item in HWlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
              </el-select>
            </el-form-item> -->
            <div style="">
              <el-form-item>
                <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
                <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
                <el-button type="primary" size="mini" @click="daochuFN">导出</el-button>
              </el-form-item>
              <span>
                <el-form-item>
                  <p class="margin0">收入总额：<span class="red">{{map.grossRevenueSum}}</span>元</p>
                </el-form-item>
              </span>
            </div>
          </el-form>
        </div>
        <!--表格1-->
        <div class="chuKuZuoyeWarp-body-table" :style="{height:h}">
          <el-table :data="tableList" ref="tabref" class="elTab" highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
          :header-cell-style="{background:'#F5F5F5',color:'black'}"
          >
            <el-table-column type="selection" width="50" fixed></el-table-column>
            <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
            <el-table-column prop="wayNo" label="运单号" :show-overflow-tooltip="true" align="center" width="230"></el-table-column>
            <el-table-column prop="incomePatternName" label="收入方式" align="center" width="90" :formatter="formatterRowEmpty">
              <!-- <template scope="scope">
                <span v-show="scope.row.incomePattern == '0'">月结</span>
                <span v-show="scope.row.incomePattern == '1'">现结</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="ysSettlementStates" label="结算状态" align="center" width="100">
              <!-- 1.未对账 0.未收款/待确认、1.部分收款、2.已付款/已确认 -->
              <template scope="scope">
                <div>
                  <span class="wsStyle" v-show="scope.row.ysSettlementStates == '-1'">未对账</span>
                  <span class="wsStyle" v-show="scope.row.ysSettlementStates == '0'">未收款</span>
                  <span class="bfStyle" v-show="scope.row.ysSettlementStates == '1'">部分收款</span>
                  <span class="ysStyle" v-show="scope.row.ysSettlementStates == '2'">已收款</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="ysInvoicingStates" label="开票状态" align="center" width="100">
              <template scope="scope">
                <!-- 0.未开票、1.部分开票、2.已开票 -->
                <div>
                  <span class="wsStyle" v-show="scope.row.ysInvoicingStates == '0'">未开票</span>
                  <span class="bfStyle" v-show="scope.row.ysInvoicingStates == '1'">部分开票</span>
                  <span class="ysStyle" v-show="scope.row.ysInvoicingStates == '2'">已开票</span>
                  <span v-show="scope.row.ysInvoicingStates===null">-</span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="payee" label="结算客户" align="center" width="220" :show-overflow-tooltip="true">
            </el-table-column> -->
            <!-- <el-table-column prop="makeTicketYn" label="是否开票" align="center" width="90">
            </el-table-column> -->
            <el-table-column prop="productTypeName" label="货物类型" align="center" width="120">
            </el-table-column>
            <!-- <el-table-column prop="liquidatedAmountName" label="结算量" align="center" width="120" :formatter="emptyFn">
            </el-table-column> -->
            <el-table-column prop="revenueValuationName" label="收入计价" align="center" width="100" :formatter="formatterRowEmpty">
              <!-- <template scope="scope">
                0.按吨、1.按车、2.按方、3.按件
                <span v-show="scope.row.revenueValuation == '0'">按吨</span>
                <span v-show="scope.row.revenueValuation == '1'">按车</span>
                <span v-show="scope.row.revenueValuation == '2'">按方</span>
                <span v-show="scope.row.revenueValuation == '3'">按件</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="" label="收入单价" align="center" width="120">
              <template scope="scope">
                <div>
                  <span v-if="scope.row.revenueValuation == '0'">{{scope.row.incomeUnitPrice}}元/吨</span>
                  <span v-if="scope.row.revenueValuation == '1'">
                    <span v-if="scope.row.incomeUnitPrice != 0">{{scope.row.incomeUnitPrice}}元/车</span>
                    <span v-else>-</span>
                  </span>
                  <span v-if="scope.row.revenueValuation == '2'">{{scope.row.incomeUnitPrice}}元/方</span>
                  <span v-if="scope.row.revenueValuation == '3'">{{scope.row.incomeUnitPrice}}元/件</span>
                  <span v-if="scope.row.revenueValuation == '' || scope.row.revenueValuation == null">-</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="incomeAmount" label="收入金额(元)" align="center" width="110" :formatter="formatterRowEmpty">
            </el-table-column>
            <!-- <el-table-column prop="taxRate" label="税率" align="center" width="80">
            </el-table-column> -->
            <!-- <el-table-column prop="incomeAmount" label="收入金额(元)" align="center" width="110">
            </el-table-column> -->
            <el-table-column prop="revenueSurcharge" label="收入附加费(元)" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="incomeTotalRevenue" label="收入总额(元)" align="center" width="110" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="incomeServiceRate" label="服务费率(%)" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <!-- <el-table-column prop="grossRevenueNoTax" label="收入不含税(元)" align="center" width="120">
            </el-table-column> -->
            <el-table-column prop="incomeServiceCharge" label="服务费(元)" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <!-- <el-table-column prop="grossRevenue" label="应收" align="center" width="120">
            </el-table-column> -->
            <el-table-column prop="ysPaymentAmount" label="已收款金额(元)" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="ysNoPaymentAmount" label="未收款金额(元)" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="ysInvoiceAmount" label="已开票金额(元)" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="ysNoInvoiceAmount" label="未开票金额(元)" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <!-- <el-table-column prop="settlementStatus" label="附加费备注" align="center" width="150">
            </el-table-column> -->
            <el-table-column prop="plateNumber" label="车牌号" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="driverName" label="司机姓名" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="driverPhone" label="司机电话" align="center" width="120" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="orderNo" label="订单号" align="center" width="240" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column prop="ysInvoiceOn" label="发票号" align="center" width="200" :formatter="formatterRowEmpty">
            </el-table-column>
            <el-table-column property="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
            <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
          </el-table>
        </div>
        <!--分页-->
        <div class="pags" style="text-align: left;">
          <el-pagination
            background
            @current-change="handleCurrentChangeA"
            :current-page="searchFrom.pageNo"
            :page-size="searchFrom.pageSize"
            :page-sizes="[10, 20, 30, 40,50]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChangeA"
            :total="total"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { findWayBusinessList, getDictionaryDetailList, findWayBusinessListTotal } from '@/api/newTMS'
import { emptyFn, dateTimeFormat, formatterRowEmpty, dateFormat1 } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'Freight',
  components: {
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      activeName: 'one',
      dateTimeFormat: dateTimeFormat,
      loading: false,
      incomeList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '月结',
          value: '0'
        },
        {
          showName: '现结',
          value: '1'
        }
      ],
      ysSettlementList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未对账',
          value: '-1'
        },
        {
          showName: '未收款',
          value: '0'
        },
        {
          showName: '部分收款',
          value: '1'
        },
        {
          showName: '已收款',
          value: '2'
        }
      ],
      ysInvoicingList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未开票',
          value: '0'
        },
        {
          showName: '部分开票',
          value: '1'
        },
        {
          showName: '已开票',
          value: '2'
        }
      ],
      HWlist: [],
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      createTimes: [],
      actualSignings: [],
      searchFrom: {
        payeeType: '1',
        ysSettlementStates: '-1',
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        wayNos: ''
      },
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['006P00GB001', '006P00GB002'],
      tableList: [],
      map: {}
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/freight')
    let startDatr = dateFormat1(new Date().getTime() - 1000 * 60 * 60 * 24 * 30, 'YYYY-MM-ss h-m-s')
    let endDate = dateFormat1(new Date().getTime(), 'YYYY-MM-ss h-m-s')
    this.createTimes = [startDatr, endDate]
    this.getList()
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 150 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      this.searchFrom.createTimeStart = this.createTimes[0]
      this.searchFrom.createTimeEnd = this.createTimes[1]
      this.searchFrom.actualSigningTimeStart = this.actualSignings[0]
      this.searchFrom.actualSigningTimeEnd = this.actualSignings[1]
      if (this.searchFrom.wayNos) {
        this.searchFrom.wayNos = this.searchFrom.wayNos.replace(/\n/g, ',')
        this.searchFrom.wayNoList = this.searchFrom.wayNos.split(',')
      } else {
        this.searchFrom.wayNos = ''
        this.searchFrom.wayNoList = null
      }
      findWayBusinessList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      findWayBusinessListTotal(this.searchFrom).then(res => {
        this.map = res
      })
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        payeeType: '1',
        ysSettlementStates: '-1',
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        wayNos: '',
        wayNoList: null
      }
      // this.createTimes = []
      let startDatr = dateFormat1(new Date().getTime() - 1000 * 60 * 60 * 24 * 30, 'YYYY-MM-ss h-m-s')
      let endDate = dateFormat1(new Date().getTime(), 'YYYY-MM-ss h-m-s')
      this.createTimes = [startDatr, endDate]
      this.actualSignings = []
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pagesize = val
      this.getList()
    },
    // 导出
    daochuFN () {
      this.searchFrom.createTimeStart = this.createTimes[0]
      this.searchFrom.createTimeEnd = this.createTimes[1]
      this.searchFrom.actualSigningTimeStart = this.actualSignings[0]
      this.searchFrom.actualSigningTimeEnd = this.actualSignings[1]
      delete this.searchFrom.pageNo
      delete this.searchFrom.pageSize
      if (this.searchFrom.wayNos) {
        this.searchFrom.wayNos = this.searchFrom.wayNos.replace(/\n/g, ',')
        this.searchFrom.wayNoList = this.searchFrom.wayNos.split(',')
      } else {
        this.searchFrom.wayNos = ''
        this.searchFrom.wayNoList = null
      }
      exportExcel(
        this.global.tmsPlus + '/settlementBill/exportOutsideYsWayList',
        this.searchFrom,
        '应收明细列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  background-color: #0c46a2 !important;
  color: #fff;
}
/deep/.el-range-editor--mini.el-input__inner {
  height: 28px;
  width: 410px !important;
}
/deep/.el-form{
  width: 100%;
}
/deep/.searchBox .el-input--mini .el-input__inner{
  width: 150px !important;
}
</style>
